import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import standalone components directly in the routes
import { HomePage } from './pages/home/home.page';
import { LoginPage } from './pages/auth/login/login.page';
import { SignUpPage } from './pages/auth/signup/signup.page';
import { ArticlePage } from './pages/article/article.page';
import { SettingsPage } from './pages/settings/settings.page';
import { WelcomePage } from './pages/welcome/welcome.page';
import { UserGuard } from './services/user.guard';
import { TourGuard } from './services/tour.guard';
import { AuthGuard } from './services/auth.guard';
import { SplashPage } from './pages/splash-page/splash-page.page';
import { BeginningPage } from './pages/beginning/beginning.page';
import { LevelPage } from './pages/level/level.page';
import { SetupPage } from './pages/setup/setup.page';
import { AudioSetupPage } from './pages/audio-setup/audio-setup.page';
import { VocabSwipePage } from './pages/vocab-swipe/vocab-swipe.page';
import { ProgressPage } from './pages/progress/progress.page';
import { GrammarHomePage } from './pages/grammar-home/grammar-home.page';
import { TopicPlaylistPage } from './pages/topic-playlist/topic-playlist.page';
import { LeaderboardPage } from './pages/leaderboard/leaderboard.page';
// Spotify OAuth pages
import { SpotifyCallbackPage } from './pages/spotify-callback/spotify-callback.page';
import { SpotifyProfilePage } from './pages/spotify-profile/spotify-profile.page';
import { LyricsLookupPage } from './pages/lyrics-lookup/lyrics-lookup.page';
import { SyncLearningPage } from './pages/sync-learning/sync-learning.page';

const routes: Routes = [
  { path: '', redirectTo: 'playlists', pathMatch: 'full' },
  { path: 'login', component: LoginPage},
  { path: 'signup', component: SignUpPage },
  // { path: 'news', component: HomePage, canActivate: [UserGuard] },
  // { path: 'news/:topic', component: HomePage },
  // { path: 'article/:id', component: ArticlePage },
  { path: 'settings', component: SettingsPage },
  // { path: 'welcome', component: WelcomePage },
  // { path: 'study', loadChildren: () => import('./pages/study/study-routing.module').then(m => m.StudyPageRoutingModule) },
  // { path: 'splash-page', component: SplashPage },
  { path: 'beginning', component: BeginningPage },
  { path: 'level', component: LevelPage },
  { path: 'setup', component: SetupPage },
  // { path: 'audio-setup', component: AudioSetupPage },
  // { path: 'vocab-swipe', component: VocabSwipePage },
  // { path: 'progress', component: ProgressPage },
  { path: 'playlists', component: GrammarHomePage },
  { path: 'topic-playlist/:language/:topic', component: TopicPlaylistPage },
  { path: 'leaderboard', component: LeaderboardPage },
  // Spotify OAuth routes — must be registered before the wildcard
  { path: 'spotify-callback', component: SpotifyCallbackPage },
  { path: 'spotify-profile',  component: SpotifyProfilePage },
  { path: 'lyrics-lookup',    component: LyricsLookupPage },
  { path: 'sync-learning',    component: SyncLearningPage },
  { path: '**', redirectTo: 'playlists', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }